"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.okColor = exports.blueLabelFontColor = exports.highlightedBlueLabelBackgroundColor = exports.blueLabelBackgroundColor = exports.highlightedWidgetBackgroundColor = exports.seatMatrixAlternateColors = exports.seatMatrixAltFreeColor4 = exports.seatMatrixAltFreeColor3 = exports.seatMatrixAltFreeColor2 = exports.seatMatrixAltFreeColor1 = exports.seatMatrixAltSelectedColor4 = exports.seatMatrixAltSelectedColor3 = exports.seatMatrixAltSelectedColor2 = exports.seatMatrixAltSelectedColor1 = exports.seatMatrixBusyColor = exports.seatMatrixDefaultSelectedColor = exports.seatMatrixDefaultFreeColor = exports.leftPaneBackgroundColor = exports.paneBorderColor = exports.paneBackgroundColor = exports.dangerColor = exports.textHighlightColor = exports.secondaryButtonColor = exports.emphasisColor = exports.defaultButtonColor = exports.topBarIdleTabColor = exports.topBarSubBgColor = exports.topBarBgColor = exports.onDarkTextColor = exports.widgetBackgroundColor = exports.widgetBorderColor = exports.grayElementColor = exports.discreetTextColor = exports.textColor = exports.thirdColor = exports.secondaryColor = exports.primaryColor = exports.lightBackgroundColor = exports.backgroundColor = exports.blackTextColor = void 0;
var blackBeans = '#2D0E44';
var snowBis = '#E5E7EF';
var pastelBeans = '#B399D4';
var blackTextColor = '#434950';
exports.blackTextColor = blackTextColor;
var backgroundColor = '#F3F4F8';
exports.backgroundColor = backgroundColor;
var lightBackgroundColor = '#FAFAFA';
exports.lightBackgroundColor = lightBackgroundColor;
var primaryColor = '#00C3A8';
exports.primaryColor = primaryColor;
var secondaryColor = '#21304D';
exports.secondaryColor = secondaryColor;
var thirdColor = '#00b9f1';
exports.thirdColor = thirdColor;
var textColor = '#343F43';
exports.textColor = textColor;
var discreetTextColor = '#95A3A7';
exports.discreetTextColor = discreetTextColor;
var grayElementColor = '#999EA1';
exports.grayElementColor = grayElementColor;
var widgetBorderColor = '#DDE2E6';
exports.widgetBorderColor = widgetBorderColor;
var widgetBackgroundColor = '#FFFFFF';
exports.widgetBackgroundColor = widgetBackgroundColor;
var onDarkTextColor = '#FFFFFF';
exports.onDarkTextColor = onDarkTextColor;
var topBarBgColor = secondaryColor;
exports.topBarBgColor = topBarBgColor;
var topBarSubBgColor = '#172236';
exports.topBarSubBgColor = topBarSubBgColor;
var topBarIdleTabColor = '#BCC0C9';
exports.topBarIdleTabColor = topBarIdleTabColor;
var defaultButtonColor = '#8A9EA1';
exports.defaultButtonColor = defaultButtonColor;
var emphasisColor = '#4D95F8';
exports.emphasisColor = emphasisColor;
var secondaryButtonColor = '#30A9DE';
exports.secondaryButtonColor = secondaryButtonColor;
var textHighlightColor = '#FFE84A';
exports.textHighlightColor = textHighlightColor;
var dangerColor = '#dd4b39';
exports.dangerColor = dangerColor;
var paneBackgroundColor = lightBackgroundColor; // '#FBFBFB';

exports.paneBackgroundColor = paneBackgroundColor;
var paneBorderColor = '#E2E8F0';
exports.paneBorderColor = paneBorderColor;
var leftPaneBackgroundColor = '#F6FBFF'; // Seat matrix

exports.leftPaneBackgroundColor = leftPaneBackgroundColor;
var seatMatrixDefaultFreeColor = '#E9E9E9';
exports.seatMatrixDefaultFreeColor = seatMatrixDefaultFreeColor;
var seatMatrixDefaultSelectedColor = '#2ECC71';
exports.seatMatrixDefaultSelectedColor = seatMatrixDefaultSelectedColor;
var seatMatrixBusyColor = '#999EA1';
exports.seatMatrixBusyColor = seatMatrixBusyColor;
var seatMatrixAltSelectedColor1 = '#F5AB35';
exports.seatMatrixAltSelectedColor1 = seatMatrixAltSelectedColor1;
var seatMatrixAltSelectedColor2 = '#FA5C98';
exports.seatMatrixAltSelectedColor2 = seatMatrixAltSelectedColor2;
var seatMatrixAltSelectedColor3 = '#9B59B6';
exports.seatMatrixAltSelectedColor3 = seatMatrixAltSelectedColor3;
var seatMatrixAltSelectedColor4 = '#FF6C5C';
exports.seatMatrixAltSelectedColor4 = seatMatrixAltSelectedColor4;
var seatMatrixAltFreeColor1 = '#FDE3A7';
exports.seatMatrixAltFreeColor1 = seatMatrixAltFreeColor1;
var seatMatrixAltFreeColor2 = '#FFBCD8';
exports.seatMatrixAltFreeColor2 = seatMatrixAltFreeColor2;
var seatMatrixAltFreeColor3 = '#DCC6E0';
exports.seatMatrixAltFreeColor3 = seatMatrixAltFreeColor3;
var seatMatrixAltFreeColor4 = '#FFCCBC';
exports.seatMatrixAltFreeColor4 = seatMatrixAltFreeColor4;
var seatMatrixAlternateColors = [// Yellow
{
  freeColor: seatMatrixAltFreeColor1,
  selectedColor: seatMatrixAltSelectedColor1
}, // Pink
{
  freeColor: seatMatrixAltFreeColor2,
  selectedColor: seatMatrixAltSelectedColor2
}, // Purple
{
  freeColor: seatMatrixAltFreeColor3,
  selectedColor: seatMatrixAltSelectedColor3
}, // Red
{
  freeColor: seatMatrixAltFreeColor4,
  selectedColor: seatMatrixAltSelectedColor4
}];
exports.seatMatrixAlternateColors = seatMatrixAlternateColors;
var highlightedWidgetBackgroundColor = '#FFF8F8';
exports.highlightedWidgetBackgroundColor = highlightedWidgetBackgroundColor;
var blueLabelBackgroundColor = 'rgba(92, 165, 223, 0.08)';
exports.blueLabelBackgroundColor = blueLabelBackgroundColor;
var highlightedBlueLabelBackgroundColor = 'rgba(190, 22, 35, 0.08)';
exports.highlightedBlueLabelBackgroundColor = highlightedBlueLabelBackgroundColor;
var blueLabelFontColor = '#5CA5DF';
exports.blueLabelFontColor = blueLabelFontColor;
var okColor = '#009A34';
exports.okColor = okColor;